
import { dislikeRedIcon, cancelIcon } from 'assets/icons';
import { Dialog } from 'primereact/dialog';
import { useState } from 'react';

function Feedback({ handlePopupClosed, feedback_text, setFeedBackText, notify, feedbackcontent, setFeedBackContent, setPopup, component }: any) {
    // const [text, setText] = useState("")
    const handleSubmitClick = () => {
        notify("Feedback submitted");
        handlePopupClosed(feedbackcontent);
    }
    // const[feedback_text, setFeedBackText] = useState(feedbackcontent)

    const footerContent = (
        <div className='dialog-footer'>
            <button className={feedbackcontent === "" ? "outline-btn" : "outline-btn"} disabled={feedbackcontent.trim() === "" || component === 'history'} onClick={() => { handleSubmitClick(); setFeedBackText(false); }}
            // style={{
            //     color: feedbackcontent === "" ? "#404040" : "#FFFFFF",
            //     borderRadius: "30px",
            //     border: feedbackcontent === "" ? "1px solid #919191" : "1px solid #013DB9",
            //     backgroundColor: feedbackcontent === "" ? "transparent" : "#013DB9",
            //     cursor: feedbackcontent === "" ? "default" : "pointer",
            // }}
            >Submit Feedback</button>
            {/* <button className='btn btn-outline-dark btn-sm ms-2' onClick={() => setFeedBackText(false)}  >Skip</button> */}
        </div>
    );

    const headerContent = (
        <div className='d-flex align-items-center dialog-heading'>
            <i>
                <img className="feedback-dislike-icon" src={dislikeRedIcon} alt="dislike" />
            </i>
            <h5 className="feedback-title mb-0 fs-6">
                Send us your Feedback!
            </h5>
        </div>
    )

    return (
        <Dialog header={headerContent} className='custom-dialogue' visible={feedback_text} onHide={() => setFeedBackText(false)} footer={footerContent}>
            <p>Do you have a suggestion or had any problem?<br />Let us know in the field below</p>
            <textarea disabled={component === 'history'} className="feedback-text-area form-control m-0" placeholder='Describe your experience here' value={feedbackcontent} onChange={(e) => setFeedBackContent(e.target.value)}></textarea>
        </Dialog>
    )
}

export default Feedback;